import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatIconRegistry, Sort } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
//import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AlertService } from 'src/app/services/alert.service';
import { ServerResponseCode } from '../scheduler/response.code.constants';
import { SupportSujet, SupportSujetUpdateRequest } from '../support-sujet-model';
import { SupportSujetService } from '../support-sujet-service.service';

@Component({
  selector: 'oap-support-sujet',
  templateUrl: './support-sujet.component.html',
  styleUrls: ['./support-sujet.component.scss']
})
export class SupportSujetComponent implements OnInit {

  displayedColumns: string[] = ['key', 'sujet', 'emailDestinataire', 'nomDestinataire', 'ordreTri', 'up', 'down', 'actif', 'actions'];
  dataSource: MatTableDataSource<SupportSujet>;
  @ViewChild(MatSort) sort: MatSort;

  mapSupportSujet: Map<number, SupportSujet>;
  currentSupportSujet: SupportSujet;

  selectedRowIndex: number = -1;

  lastOrderTri: number = 1;

  listTitle: string;
  typeSupportSujet: string;
  supportSujetConnected: boolean;
  informations: string;
  tooltip_edit="Modifier"
  tooltip_delete="Supprimer définitivement le sujet"
  tooltip_move_up="Monte l'ordre d'affichage"
  tooltip_move_down="Descend l'ordre d'affichage"

  constructor(//private _router: Router,
    private alertService: AlertService,
    private supportSujetService : SupportSujetService,
    private _route: ActivatedRoute,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) { 
      iconRegistry.addSvgIcon('edit', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-edit-24px.svg'));
      iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-delete-24px.svg'));
      iconRegistry.addSvgIcon('up', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/keyboard_arrow_up_black_24dp.svg'));
      iconRegistry.addSvgIcon('down', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/keyboard_arrow_down_black_24dp.svg'));
    }

  ngOnInit() {    
    this.alertService.clear();

    this._route.queryParams.subscribe(params => {
      this.typeSupportSujet = params['typeSupportSujet'];
    });

    console.info('typeSupportSujet : ' + this.typeSupportSujet);

    this.supportSujetConnected = this.typeSupportSujet === 'connected' ? true : false;

    if(this.supportSujetConnected) {
      this.listTitle = 'Liste des sujets connectés';
    } else {
      this.listTitle = 'Liste des sujets non connectés';
    }

    this.sort.sort({
      id: "ordreTri",
      start: "asc",
      disableClear: true
    });

    this.loadListSupportsujet();

  }

  private loadListSupportsujet() {
    this.lastOrderTri = 1;
    this.supportSujetService.getSupportSujets(this.supportSujetConnected)
    .subscribe(
      response => {
          console.log('http response  status : ' + response.status);
          let data = response.body;

          const results: SupportSujet[] = [];
          this.mapSupportSujet = new Map<number, SupportSujet>();
          data.forEach(element => {
            let entity: SupportSujet = createSupportSujet(element);
            results.push(entity);
            this.mapSupportSujet.set(entity.key, entity);

            if(entity.actif && entity.ordreTri > this.lastOrderTri) {
              this.lastOrderTri = entity.ordreTri;
            }

          });
          this.dataSource = new MatTableDataSource(results);
          this.sortData();

        },
        error => {
          console.error(error)
        });
  }

  onSortData(sort: Sort) {
    this.sortData();
  }

  private sortData() {
    console.log("sorData")
    if (!this.dataSource) {
      return;
    }

    const data = this.dataSource.data;

    let sort: Sort = {
      active: this.sort.active,
      direction: this.sort.direction
    };

    if (!sort.active || sort.direction === '') {
      // tri par défaut
      sort = {
        active: "",
        direction: ""
      };
    }

    this.dataSource = new MatTableDataSource( data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'key': return compare(a.key, b.key, isAsc);
        case 'ordreTri': return compare(a.ordreTri, b.ordreTri, isAsc);
        case 'sujet': return compare(a.sujet.toLocaleLowerCase(), b.sujet.toLocaleLowerCase(), isAsc);
        case 'emailDestinataire': return compare(a.emailDestinataire, b.emailDestinataire, isAsc);
        case 'nomDestinataire': return compare(a.nomDestinataire.toLowerCase(), b.nomDestinataire.toLowerCase(), isAsc);
        default: return compare(a.key, b.key, true);
      }
    }));
  }

  onRowClick() {
    console.log(' onRowClick ' );
    this.alertService.clear();
  }

  toggleActif(supportSujet: SupportSujet) {
    console.log(' toggleActif :' + supportSujet.key);
    
    supportSujet.actif = !supportSujet.actif;

    const updateSupportSujet: SupportSujetUpdateRequest = {
      sujet: supportSujet.sujet,
      emailDestinataire: supportSujet.emailDestinataire,
      nomDestinataire: supportSujet.nomDestinataire,
      actif: supportSujet.actif,
      publique: supportSujet.publique,
      ordreTri: supportSujet.ordreTri
    };

    this.supportSujetService.update(supportSujet.key, updateSupportSujet, 'up')
      .pipe(first())
      .subscribe(
        response => {
          let data = response.body;
          let entity: SupportSujet = createSupportSujet(data);
          this.mapSupportSujet.set(entity.key, entity);
          supportSujet.actif = entity.actif;
          supportSujet.publique = entity.publique;

          this.alertService.success('Mise à jour réussie', false);

          this.loadListSupportsujet();
        },
        error => {
          console.error(error)
        });

        
  }

  togglePublique(supportSujet: SupportSujet) {
    console.log(' togglePublique :' + supportSujet.key);
    
    supportSujet.publique = !supportSujet.publique;

    const updateSupportSujet: SupportSujetUpdateRequest = {
      sujet: supportSujet.sujet,
      emailDestinataire: supportSujet.emailDestinataire,
      nomDestinataire: supportSujet.nomDestinataire,
      actif: supportSujet.actif,
      publique: supportSujet.publique,
      ordreTri: supportSujet.ordreTri
    };

    this.supportSujetService.update(supportSujet.key, updateSupportSujet, 'up')
      .pipe(first())
      .subscribe(
        response => {
          let data = response.body;
          let entity: SupportSujet = createSupportSujet(data);
          this.mapSupportSujet.set(entity.key, entity);
          supportSujet.actif = entity.actif;
          supportSujet.publique = entity.publique;

          this.alertService.success('Mise à jour réussie', false);
        },
        error => {
          console.error(error)
        });
  }

  updateDisplayOrderSupportSujet(supportSujetKey: number, direction: string) {
    this.lastOrderTri = 1;
    this.supportSujetService.updateDisplayOrder(supportSujetKey, direction)
      .pipe(first())
      .subscribe(
        response => {
          let data = response.body;

          const results: SupportSujet[] = [];
          this.mapSupportSujet = new Map<number, SupportSujet>();
          data.forEach(element => {
            let entity: SupportSujet = createSupportSujet(element);
            results.push(entity);
            this.mapSupportSujet.set(entity.key, entity);

            if(entity.actif && entity.ordreTri > this.lastOrderTri) {
              this.lastOrderTri = entity.ordreTri;
            }

          });
          this.dataSource = new MatTableDataSource(results);
          this.sortData();

        },
        error => {
          console.error(error)
        });
  }

  deleteSupportSujet(supportSujetKey: number) {
    this.supportSujetService.delete(supportSujetKey)
    .pipe(first())    
    .subscribe(
      response => {
        console.log('http response status : ' + response.status);
        if (response.status == ServerResponseCode.SUCCESS) {
          this.alertService.success('Suppression réussie', false);
        } else {
          this.alertService.error('Impossible de supprimer le sujet (contacter le support)', false);
        }

        //For updating list
        this.loadListSupportsujet();
      },
      err => {
        this.alertService.error('Impossible de supprimer le sujet (contacter le support)', false);
        console.log(err);
      });
  }

}

function compare(a, b, isAsc) {
  if (a === null) {
    return 1 * (isAsc ? 1 : -1);
  }
  if (b === null) {
    return -1 * (isAsc ? 1 : -1);
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/** Builds and returns a new SearchResultData. */
function createSupportSujet(data: any): SupportSujet {
  return {
    key: data.key,
    sujet: data.sujet,
    emailDestinataire: data.emailDestinataire,
    nomDestinataire: data.nomDestinataire,
    actif: data.actif,
    publique: data.publique,
    ordreTri: data.ordreTri
  };  
}
